import ClockSvg from '@/shared/assets/icons/sidebar/clock.svg';
import DashboardSvg from '@/shared/assets/icons/sidebar/dashboard.svg';
import HistoricalSvg from '@/shared/assets/icons/sidebar/historical.svg';
import ManagementSvg from '@/shared/assets/icons/sidebar/management.svg';
import OilAnalysisSvg from '@/shared/assets/icons/sidebar/oil-analysis.svg';
import OverviewSvg from '@/shared/assets/icons/sidebar/overview.svg';
import PlantTrackSvg from '@/shared/assets/icons/sidebar/select-plant.svg';
import ShipSvg from '@/shared/assets/icons/sidebar/select-ship.svg';
import VirtualCockpitSvg from '@/shared/assets/icons/sidebar/virtual-cockpit.svg';
import YachtTrackSvg from '@/shared/assets/icons/sidebar/yacht-track.svg';
import { AppRoutes } from '@/shared/constants/app-routes.constant';

import { NavigationItem } from '../types/navigation-item.interface';

export const navigationList: NavigationItem[] = [
	{
		routes: [
			{
				Svg: OverviewSvg,
				label: 'sidebar.navigation.data.multi.yacht',
				href: AppRoutes.MultiYachtView,
				canShow: (_, hasMultipleEntities) => hasMultipleEntities,
				dynamicHref: ({ multiView }) => multiView,
				dynamicLabel: ({ sidebarMultiView }) => sidebarMultiView,
			},
			{
				Svg: ShipSvg,
				label: 'sidebar.navigation.data.yacht',
				href: AppRoutes.YachtView,
				dynamicHref: ({ singleView }) => singleView,
				dynamicLabel: ({ sidebarSingleView }) => sidebarSingleView,
				dynamicSvg: (isPlant) => (isPlant ? PlantTrackSvg : ShipSvg),
			},
			{
				Svg: YachtTrackSvg,
				label: 'sidebar.navigation.data.yachtTrack',
				href: AppRoutes.YachtTrack,
				canShow: (isPlant) => !isPlant,
			},
			{ Svg: VirtualCockpitSvg, label: 'sidebar.navigation.data.virtual', href: AppRoutes.VirtualCockpit },
			{ Svg: HistoricalSvg, label: 'sidebar.navigation.data.historical', href: AppRoutes.HistoricalData },
			{ Svg: DashboardSvg, label: 'sidebar.navigation.data.dashboard', href: AppRoutes.Dashboard },
		],
	},
	{
		title: 'sidebar.navigation.alarm.title',
		routes: [{ Svg: ManagementSvg, label: 'sidebar.navigation.alarm.management', href: AppRoutes.AlarmManagement }],
	},
	{
		title: 'sidebar.navigation.maintenance.title',
		routes: [
			{
				Svg: ClockSvg,
				label: 'sidebar.navigation.maintenance.automated.plan',
				href: AppRoutes.AutomatedPlan,
				canShow: (_, __, automatedPlanAccess) => automatedPlanAccess,
			},
			{ Svg: OilAnalysisSvg, label: 'sidebar.navigation.data.oil.analysis', href: AppRoutes.OilAnalysis },
		],
	},
];
